"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.gridContainerDirection = exports.gridContainerAlignItems = exports.gridContainerJustify = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AppTheme = _interopRequireDefault(require("../../../AppTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ** Mobile 0px - 767px **
 *
 * The grid has 12 columns with 16px gutter and a 16px margin.
 *
 * ** Tablet 768px - 1024px **
 *
 * The grid has 12 columns with 20px gutter and a 20px margin.
 *
 * ** 1025px - 1440px **
 *
 * The grid has12 columns with 20px gutter and a 20px margin.
 *
 * ** Notice **
 *
 * ** Side margins are given accordingly by the BoxContainer component **
 *
 */
var GridContainer = function GridContainer(_ref) {
  var justify = _ref.justify,
      alignItems = _ref.alignItems,
      direction = _ref.direction,
      wrap = _ref.wrap,
      disableGutters = _ref.disableGutters,
      isDense = _ref.isDense,
      children = _ref.children;
  var media = (0, _core.useMediaQuery)(_AppTheme.default.breakpoints.down('xs'));
  var gutterSize = media ? 2 : 3;
  var gutterSizeDense = media ? 1 : 2;
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    justify: justify,
    alignItems: alignItems,
    wrap: wrap,
    direction: direction,
    spacing: !disableGutters && (isDense ? gutterSizeDense : gutterSize)
  }, children);
};

GridContainer.propTypes = {
  /** Display Flex Justify content option */
  justify: _propTypes.default.oneOf(["flex-start", "center", "flex-end", "space-between", "space-around", "space-evenly"]),

  /** Display Flex align items option */
  alignItems: _propTypes.default.oneOf(["flex-start", "center", "flex-end", "stretch", "baseline"]),

  /** Display Flex direction */
  direction: _propTypes.default.oneOf(["row", "row-reverse", "flex-end", "column", "column-reverse"]),

  /** Display Flex wrap */
  wrap: _propTypes.default.oneOf(["wrap", "nowrap", "wrap-reverse"]),

  /** Disable the gutters of the grid */
  disableGutters: _propTypes.default.bool,

  /** Dense variant of the grid (mobile 8px, tablet - desktop 16px) */
  isDense: _propTypes.default.bool,

  /** Dense variant of the grid (mobile 8px, tablet - desktop 16px) */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node])
};
GridContainer.defaultProps = {
  justify: "flex-start",
  alignItems: "flex-start",
  direction: "row",
  wrap: "wrap",
  disableGutters: false,
  isDense: false,
  children: null
};
var gridContainerJustify = ["flex-start", "center", "flex-end", "space-between", "space-around", "space-evenly"];
exports.gridContainerJustify = gridContainerJustify;
var gridContainerAlignItems = ["flex-start", "center", "flex-end", "stretch", "baseline"];
exports.gridContainerAlignItems = gridContainerAlignItems;
var gridContainerDirection = ["row", "row-reverse", "flex-end", "column", "column-reverse"];
exports.gridContainerDirection = gridContainerDirection;
var _default = GridContainer;
exports.default = _default;